export default {
  GSO: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    // paragraph: `<ul>
    //       <li>Online parking rates may differ from drive-up parking rates.</li>
    //       <li>An overstay fee equal to $36/day for Lot A, $27/day for Lot B, and $19/day for Lot C will apply if exiting after the reserved time.</li>
    //       <li>You are responsible for overstay fees, regardless of cause (flight delays, weather, etc…)</li>
    //       <li>Cancel up to 24-hours in advance of your reserved entry time for a full-refund. No refunds will be provided for cancellations within 24-hours of your reserved entry time.</li>
    //       <li>View full terms and conditions here: <a href="/terms.html" target="_blank">Terms & Conditions</a></li>
    //     </ul>`,
    terms: {
      textKey: `* Click here to accept PTI Parking {termsUrl} which includes Privacy information as to data collection and usage.`,
      termsUrl: "https://flyfrompti.com/parking-terms-conditions/",
      termsUrlText: "terms & conditions"
    },
    privacy: {
      privacyUrl: "https://flyfrompti.com/privacy-policy/"
    },
    marketing: {
      textKey: "Subscribe to receive exclusive offers and updates from Piedmont Triad International Airport.",
    }
  },
  ST1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    // paragraph: `<ul>
    //       <li>Online parking rates may differ from drive-up parking rates.</li>
    //       <li>An overstay fee equal to $36/day for Lot A, $27/day for Lot B, and $19/day for Lot C will apply if exiting after the reserved time.</li>
    //       <li>You are responsible for overstay fees, regardless of cause (flight delays, weather, etc…)</li>
    //       <li>Cancel up to 24-hours in advance of your reserved entry time for a full-refund. No refunds will be provided for cancellations within 24-hours of your reserved entry time.</li>
    //       <li>View full terms and conditions here: <a href="/terms.html" target="_blank">Terms & Conditions</a></li>
    //     </ul>`,
    terms: {
      textKey: `Yes, I have read and agree to the {termsUrl}.`,
      termsUrl: "https://res.cloudinary.com/rezcomm2018/image/upload/v1787046789/abm/STL_Terms.pdf",
      termsUrlText: "Terms and Conditions"
    },
    privacy: {
      privacyUrl: "https://www.abm.com/privacy-policy"
    },
    marketing: {
      textKey: "Subscribe to receive exclusive offers and updates.",
    }
  },
  FM1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Marketing Permissions",
    paragraph: "Please confirm that you have read and accepted the terms and conditions.",
    terms: {
      textKey: `Yes, I have read and agree to the <a href="{termsUrl}" target="_blank">terms & conditions</a>.`,
      termsUrl: "https://www.memmingen-airport.com/parking-terms-and-conditions"
    },
    privacy: {
      textKey: `Yes, I have read and agree to the {privacyUrl}.`,
      privacyUrl: "https://www.memmingen-airport.com/privacy-policy",
      privacyUrlText: "Privacy Policy"
    },
    marketing: {
      consentType: "dual",
      textKey: `<b>From time to time, Flughafen Memmingen GmbH would like to contact you by email with news and special offers on parking and other services. Please check the box to allow us to do this.</b>`,
      textKeyAgree: "I DO agree.",
      textKeyDisagree: "I DO NOT agree.",
      infoText: ""
    }
  },
  FMM: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account.",
      privacyNoticeText: "Privacy Policy"
    },
    title: "Terms & Conditions, Data protection and Newsletters",
    paragraph: "",
    terms: {
      textKey: `Yes, I have read and agree to the {privacyUrl} & the {termsUrl}.`,
      termsUrl: "https://www.memmingen-airport.com/parking-general-terms-and-conditions/",
      termsUrlText: "General Terms and Conditions",
      privacyUrl: "https://www.memmingen-airport.com/data-protection-2/",
      privacyUrlText: "Privacy Policy"
    },
    privacy: {
      privacyUrl: "https://www.memmingen-airport.com/data-protection-2/",
      privacyUrlText: "Privacy Policy"
    },
    marketing: {
      textKey: "From time to time, Flughafen Memmingen GmbH would like to contact you by email with news and special offers on parking and other services. Please check the box to allow us to do this."
    }
  },
  HER: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: "I accept the <a href='{termsUrl}' target='_blank'>Terms</a> and <a href='{privacyUrl}' target='_blank'>Privacy Notice</a>.",
      termsUrl: "https://hermesairports.com/terms",
      privacyUrl: "https://hermesairports.com/privacy"
    },
    privacy: {
      textKey: "Yes, I have read and agree to the <a href='{privacyUrl}' target='_blank'>Privacy Notice</a>.",
      privacyUrl: "https://hermesairports.com/privacy"
    },
    marketing: {
      textKey: "I agree to receive offers from Hermes Airports. See our <a href='{marketingUrl}' target='_blank'>Marketing Policy</a>.",
      marketingUrl: "https://hermesairports.com/marketing"
    }
  },
  HVN: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Waiting Time & Privacy Policy",
    paragraph: `
    <ul>
      <li>
        Online parking rates may differ from drive-up parking rates.
      </li>
      <li>
        An overstay fee equal to $39/day for Lot A, $29/day for Lot B,
        and $21/day for Lot C will apply if exiting after the reserved
        time.
      </li>
      <li>
        You are responsible for overstay fees, regardless of cause
        (flight delays, weather, etc…)
      </li>
      <li>
        Cancel up to 24-hours in advance of your reserved entry time
        for a full-refund. No refunds will be provided for
        cancellations within 24-hours of your reserved entry time.
      </li>
      <li>
        View full terms and conditions here: (Terms and conditions
        link)
      </li>
    </ul>
    `,
    terms: {
      textKey: `
        <ul>
          <li>Online parking rates may differ from drive-up parking rates.</li>
          <li>An overstay fee equal to $39/day for Lot A, $29/day for Lot B, and $21/day for Lot C will apply if exiting after the reserved time.</li>
          <li>You are responsible for overstay fees, regardless of cause (flight delays, weather, etc…)</li>
          <li>Cancel up to 24-hours in advance of your reserved entry time for a full-refund. No refunds will be provided for cancellations within 24-hours of your reserved entry time.</li>
          <li>View full terms and conditions here: <a href="{termsUrl}" target="_blank">Terms & Conditions</a></li>
        </ul>
      `,
      termsUrl: "https://flytweed.com/terms-and-conditions"
    },
    marketing: {
      textKey: "Subscribe to receive exclusive offers and updates from Tweed-New Haven Airport."
    }
  },
  INV: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept <a href='{termsUrl}' target='_blank'>Terms & Conditions</a> which includes privacy information as to data collection and usage.`,
      required: true,
      termsUrl: "https://invernessairport.com/terms-and-conditions"
    },
    marketing: {
      consentType: "dual", // "dual" for INV, "single" for most brands
      textKey: "Inverness Airport is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:<br><br>",
      textKeyAgree: "<b>I DO</b> agree to receive the following communications from Inverness Airport.",
      textKeyDisagree: "<b>I DO NOT</b> agree to receive the following communications from Inverness Airport.",
      infoText: "You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href='{privacyUrl}' target='_blank'>Privacy Policy.</a>",
      privacyUrl: "https://invernessairport.com/privacy-policy",
      marketingUrl: "https://invernessairport.com/privacy-policy"
    }
  },
  IP1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Marketing Permissions",
    marketing: {
      textKey: "I consent to receive emails from iPark Glasgow",
      infoText: `iPark Glasgow will use the information you provide on this form to get in touch with you and to provide updates and marketing.\n\nWe ask that you read our <a target="_blank" class="BF-marketing-link" href="/privacy.html">Privacy Policy</a> which explains your legal rights and how we will use your personal data.`
    }
  },
  JER: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: "Click here to accept Jersey Airport <a href='{termsUrl}' target='_blank'>{Terms & Conditions}</a> which includes privacy information as to data collection and usage.",
      termsUrl: "https://jerseyairport.com/terms"
    },
    marketing: {
      textKey: `Keep me up to date with the latest offers and updates from:<ul style='margin-top: 0.5rem; margin-left: -1rem; font-weight: 600;'><li>Ports of Jersey</li><li>Jersey Airport</li></ul>`,
    }
  },
  LAX: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: "I have read and agree to the <a href='{termsUrl}' target='_blank'>Terms & Conditions</a> and <a href='{privacyUrl}' target='_blank'>Privacy Policy</a>.",
      termsUrl: "https://lax.com/terms",
      privacyUrl: "https://lax.com/privacy"
    },
    privacy: {
      textKey: "Yes, I have read and agree to the <a href='{privacyUrl}' target='_blank'>Privacy Policy</a>.",
      privacyUrl: "https://lax.com/privacy"
    },
    // marketing: {
    //   textKey: "I consent to receive communications, exclusive offers, and promotional materials from <b>LAX Parking</b>. <span>You can unsubscribe at any time.</span>",
    //   required: true
    // }
  },
  LDY: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept <a href='{termsUrl}' target='_blank'>Terms & Conditions</a> which includes privacy information as to data collection and usage.`,
      termsUrl: "https://cityofderryairport.com/terms-and-conditions"
    },
    marketing: {
      consentType: "dual",
      textKey: "City of Derry Airport will use the information you provide on this form to get in touch with you and to provide updates and marketing:",
      textKeyAgree: "I DO agree to receive the following communications from City of Derry Airport.",
      textKeyDisagree: "I DO NOT agree to receive the following communications from City of Derry Airport.",
      infoText: `You can change your mind at any time by clicking the unsubscribe link in the footer of any email or text you receive from us, or by contacting us at <a href="mailto:parking@cityofderryairport.co.uk" target="_blank">parking@cityofderryairport.co.uk</a>. We will treat your information with respect. For more information about our privacy practices please <a href="{privacyUrl}" target="_blank">visit our website</a>. By clicking below, you agree that we may process your information in accordance with these terms.`,
      privacyUrl: "https://cityofderryairport.com/privacy-policy"
    }
  },
  ML1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept the <a href='{termsUrl}' target='_blank'>Terms & Conditions</a>.`,
      termsUrl: "https://mdlmarinas.co.uk/terms-and-conditions"
    },
    marketing: {
      textKey: "Subscribe to receive exclusive offers and updates from MDL Marinas."
    }
  },
  NOC: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept <a href='{termsUrl}' target='_blank'>Terms & Conditions</a> which includes privacy information as to data collection and usage.`,
      termsUrl: "https://irelandwestairport.com/terms-and-conditions"
    },
    marketing: {
      consentType: "dual",
      textKey: "Ireland West Airport is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you (by email) to inform you about car parking promotions and discounts, which are exclusive to our online parking customers as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick the box below to confirm your preference:",
      textKeyAgree: "I consent to receiving marketing emails about car park promotions from Ireland West Airport.",
      textKeyDisagree: "I do not wish to receive marketing emails about car park promotions from Ireland West Airport.",
      infoText: `You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href="{privacyUrl}" target="_blank">Privacy Policy.</a>`,
      privacyUrl: "https://irelandwestairport.com/privacy-policy"
    }
  },
  NQY: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept <a href='{termsUrl}' target='_blank'>Terms & Conditions</a> which includes privacy information as to data collection and usage.`,
      termsUrl: "https://cornwallairportnewquay.com/terms-and-conditions"
    },
    marketing: {
      consentType: "dual",
      textKey: "Cornwall Airport Newquay is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:",
      textKeyAgree: "I DO agree to receive the following communications from Cornwall Airport Newquay.",
      textKeyDisagree: "I DO NOT agree to receive the following communications from Cornwall Airport Newquay.",
      infoText: `You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href="{privacyUrl}" target="_blank">Privacy Policy.</a>`,
      privacyUrl: "https://cornwallairportnewquay.com/privacy-policy"
    }
  },
  NWI: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Yes, I have read the <a href="{termsUrl}" target="_blank" rel="noopener noreferrer">terms and conditions</a> and the <a href="{privacyUrl}" target="_blank" rel="noopener noreferrer">data privacy policy</a> and agree to them.`,
      termsUrl: "https://www.norwichairport.co.uk/car-park-terms-conditions/",
      privacyUrl: "https://www.norwichairport.co.uk/privacy-policy/"
    },
    marketing: {
      consentType: "dual",
      textKey: "",
      textKeyAgree: "I consent to receive emails from the airport",
      textKeyDisagree: "I do not consent to receive emails from the airport",
      infoText: `We will use the information you provide on this form to get in touch with you and to provide updates and marketing. Please let us know all the ways you would like to hear from us:<br><br>You can change your mind at any time by clicking the unsubscribe link in the footer of any email or text you receive from us. We will treat your information with respect. For more information about our privacy practices please visit our website. By clicking below, you agree that we may process your information in accordance with these terms.`
    }
  },
  PB1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Terms and conditions, data protection and newsletter",
    paragraph: "Please confirm that you have read and agree to the General Terms and Conditions.",
    terms: {
      textKey: `I have read the <a href="https://pbw.de/?menu=rechtliches" target="_blank">General Terms and Conditions</a> and agree to them.`,
      termsUrl: "https://pbw.de/?menu=rechtliches"
    },
    // Uncomment and use if you want a separate privacy checkbox
    // privacy: {
    //   textKey: `I have taken note of the <a href="https://pbw.de/?menu=home" target="_blank">information on data protection</a>. *`,
    //   privacyUrl: "https://pbw.de/?menu=home"
    // },
    marketing: {
      textKey: `I agree to receive news about PBW - Parken Verbindet, such as new parking and service offers. Information on data protection can be found <a href="https://pbw.de/?menu=rechtliches" target="_blank">here</a>.`
    }
  },
  PIT: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Information, plus Exclusive PIT Parking Offers",
    terms: {
      textKey: `Click here to accept PIT "<a href='{termsUrl}' target='_blank'>Information</a>" which includes privacy information as to data collection and usage.`,
      termsUrl: "https://pitstaging.rezcomm.com/terms.html"
    },
    marketing: {
      textKey: "Keep me up to date with the latest offers and updates from PIT Airport. De-select to opt out."
    }
  },
  RDU: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `Click here to accept ParkRDU "<a href='{termsUrl}' target='_blank'>Terms & Conditions</a>" which includes privacy information as to data collection and usage.`,
      termsUrl: "https://parkrdu.com/terms-and-conditions"
    },
    marketing: {
      textKey: "Keep me up to date with the latest offers and updates from RDU Airport. De-select to opt out."
    }
  },
  RSW: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `I accept RSW "<a href='{termsUrl}' target='_blank'>Terms & Conditions</a>" which includes privacy information as to data collection and usage.`,
      termsUrl: "https://flyrsw.com/terms-and-conditions"
    },
    marketing: {
      textKey: "Keep me up to date with the latest offers and updates from RSW Airport. De-select to opt out."
    }
  },
  SV1: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Email Permissions",
    terms: {
      textKey: `I agree to the <a href="{termsUrl}" target="_blank">Terms of Service</a> and <a href="{privacyUrl}" target="_blank">Privacy Policy</a>.`,
      termsUrl: "https://summit.example.com/terms", // Replace with actual Summit terms URL
      privacyUrl: "https://summit.example.com/privacy" // Replace with actual Summit privacy URL
    },
    marketing: {
      textKey: "I would like to receive emails and special offers from the Summit team."
    }
  },
  SZG: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Terms and conditions, data protection and newsletter",
    paragraph: "Please confirm that you have read and agree to the General Terms and Conditions.",
    terms: {
      textKey: 'I have read and agree to the <a target="_blank" href="https://www.salzburg-airport.com/parken/einstellbedingungen">General Terms and Conditions for Online Parking at Salzburg Airport=</a> and the <a target="_blank" href="https://www.salzburg-airport.com/parken/allgemeine-geschaeftsbedingungen-online-parken"> Parking Conditions</a>.'
    },
    privacy: {
      textKey: 'I have taken note of the <a target="_blank" href="https://www.salzburg-airport.com/footer/legal/datenschutz"> information on data protection (chapter 19 Parking)</a>.',
      privacyUrl: "https://www.salzburg-airport.com/footer/legal/datenschutz"
    },
    marketing: {
      textKey: 'I agree to receive news about Salzburg Airport, such as new parking and service offers, information about the flight schedule, important passenger information and events at Salzburg Airport. Information on data protection can be found under <a target="_blank" href="https://www.salzburg-airport.com/footer/legal/datenschutz">Data protection (Chapter 5, Newsletter registration)</a>.'
    }
  },
  YHM: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    terms: {
      textKey: `I have read and agree to the <a target="_blank" href="{termsUrl}">Terms & Conditions</a> and <a target="_blank" href="{privacyUrl}">Privacy Policy</a>`,
      termsUrl: "https://flyhamilton.ca/terms-and-conditions",
      privacyUrl: "https://flyhamilton.ca/privacy-policy"
    },
    marketing: {
      textKey: "I consent to receive communications and exclusive offers from Hamilton International"
    },
    privacy: {
      textKey: `To learn more about how your data is collected and used, visit our <a target="_blank" href="https://flyhamilton.ca/privacy-policy">Privacy Policy.</a>`
    },
  },
  NUE: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Terms and conditions, data protection and newsletter",
    paragraph: "Please confirm that you have read and agree to the General Terms and Conditions.",
    terms: {
      textKey: 'I have read and agree to the <a target="_blank" href="https://www.salzburg-airport.com/parken/einstellbedingungen">General Terms and Conditions for Online Parking at Salzburg Airport</a> and the <a target="_blank" href="https://www.salzburg-airport.com/parken/allgemeine-geschaeftsbedingungen-online-parken">Parking Conditions</a>.'
    },
    privacy: {
      textKey: 'I have taken note of the <a target="_blank" href="https://www.salzburg-airport.com/footer/legal/datenschutz"> information on data protection (chapter 19 Parking)</a>.',
      privacyUrl: "https://www.salzburg-airport.com/footer/legal/datenschutz"
    },
    marketing: {
      textKey: 'I agree to receive news about Salzburg Airport, such as new parking and service offers, information about the flight schedule, important passenger information and events at Salzburg Airport. Information on data protection can be found under <a target="_blank" href="https://www.salzburg-airport.com/footer/legal/datenschutz">Data protection (Chapter 5, Newsletter registration)</a>.'
    }
  },
  BFS: {
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    title: "Marketing Permissions",
    terms: {
      textKey: `<b>I consent to receive emails from Belfast International Airport</b><br /><br /> Belfast International Airport will use the information you provide on this form to get in touch with you and to provide updates and marketing.<br /><br />We ask that you read our <a target="_blank" class="BF-marketing-link" href="/privacy.html">Privacy Policy</a> which explains your legal rights and how we will use your personal data.`
    },
    continue: {
      preParagraph: `By placing this order you agree to our <a href="/terms.html" target="_blank">Terms and Conditions</a>`,
      buttonText: "Continue"
    },
  },
  BHX: {
    title: "Marketing Permissions",
    paragraph: `<p> Birmingham Airport and NCP would like to send you the latest information on new destinations, airline offers and commercial partner offers via email. Please tick this box if you would like to receive our emails. If at any time you no longer wish to receive information from Birmingham Airport, you can unsubscribe by clicking on the “unsubscribe” button which will be on the bottom of all marketing emails you receive from us. </p><p> We ask that you read our <a target="_blank" href="https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-marketing-privacy-notice/">Marketing Privacy Policy</a> which explains your legal rights and how we will use your personal data. </p>`,
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    continue: {
      buttonText: "Continue"
    },
    // terms: {
    //   textKey: `We ask that you read our {privacyUrl} and/or {termsUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
    //   termsUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-express-lane-privacy-notice/",
    //   termsUrlText: "Express Lane Privacy Policy",
    //   privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-parking-privacy-notice/",
    //   privacyUrlText: "Parking Privacy Policy"
    // },
    alternativeTerms: {
      title: "Birmingham Airport Bookings",
      paragraph: `We ask that you read our {privacyUrl} and/or {termsUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      termsUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-express-lane-privacy-notice/",
      termsUrlText: "Express Lane Privacy Policy",
      privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-parking-privacy-notice/",
      privacyUrlText: "Parking Privacy Policy",

      label: `* Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "/terms.html",
      termsLabelUrlText: "Terms & Conditions",
    },
    marketing: {
      consentType: "dual",
      textKey: ``,
      textKeyAgree: " I DO agree to receive communications from Birmingham Airport.",
      textKeyDisagree: " I DO NOT agree to receive communications from Birmingham Airport.",
      infoText: `<p> You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href="https://www.birminghamairport.co.uk/data-protection/privacy-notices/" target="_blank">Privacy Policy. </a></p>`
    },
    privacy: {
      privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/"
    },
  },
  BH2: {
    title: "Marketing Permissions",
    paragraph: `<p> Birmingham Airport and NCP would like to send you the latest information on new destinations, airline offers and commercial partner offers via email. Please tick this box if you would like to receive our emails. If at any time you no longer wish to receive information from Birmingham Airport, you can unsubscribe by clicking on the “unsubscribe” button which will be on the bottom of all marketing emails you receive from us. </p><p> We ask that you read our <a target="_blank" href="https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-marketing-privacy-notice/">Marketing Privacy Policy</a> which explains your legal rights and how we will use your personal data. </p>`,
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    continue: {
      buttonText: "Continue"
    },
    // terms: {
    //   textKey: `We ask that you read our {privacyUrl} and/or {termsUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
    //   termsUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-express-lane-privacy-notice/",
    //   termsUrlText: "Express Lane Privacy Policy",
    //   privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-parking-privacy-notice/",
    //   privacyUrlText: "Parking Privacy Policy"
    // },
    alternativeTerms: {
      title: "Birmingham Airport Bookings",
      paragraph: `We ask that you read our {privacyUrl} and/or {termsUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      termsUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-express-lane-privacy-notice/",
      termsUrlText: "Express Lane Privacy Policy",
      privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/birmingham-airport-parking-privacy-notice/",
      privacyUrlText: "Parking Privacy Policy",

      label: `* Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "/terms.html",
      termsLabelUrlText: "Terms & Conditions",
    },
    marketing: {
      consentType: "dual",
      textKey: ``,
      textKeyAgree: " I DO agree to receive communications from Birmingham Airport.",
      textKeyDisagree: " I DO NOT agree to receive communications from Birmingham Airport.",
      infoText: `<p> You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href="https://www.birminghamairport.co.uk/data-protection/privacy-notices/" target="_blank">Privacy Policy. </a></p>`
    },
    privacy: {
      privacyUrl: "https://www.birminghamairport.co.uk/data-protection/privacy-notices/"
    },
  },
  SB2: {
    title: "Marketing Permissions",
    // paragraph: `We would like to send you the latest information, offers and commercial partner offers via email. Please tick this box if you would like to receive our emails. If at any time you no longer wish to receive information from us, you can unsubscribe by clicking on the “unsubscribe” button which will be on the bottom of all marketing emails you receive from us.<br><br>
    // We ask that you read our Marketing <a target="_blank" href="https://stpancras-highspeed.com/privacy-policy/">Privacy Policy</a> which explains your legal rights and how we will use your personal data.`,
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    alternativeTerms: {
      title: "Bookings",
      paragraph: `We ask that you read our {privacyUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/",
      privacyUrlText: "Privacy Policy",

      label: `Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "https://www.sabaparking.co.uk/en/payment-services-terms-and-conditions",
      termsLabelUrlText: "Terms & Conditions",
    },
    // marketing: {
    //   consentType: "dual",
    //   preSelectDisagree: true, // Pre-select the "disagree" option for dual consent
    //   textKey: ``,
    //   textKeyAgree: " I DO agree to receive communications from London St Pancras Highspeed.",
    //   textKeyDisagree: " I DO NOT agree to receive communications from London St Pancras Highspeed.",
    //   infoText: `<p> You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our <a href="https://stpancras-highspeed.com/privacy-policy/" target="_blank">Privacy Policy. </a></p>`
    // },
    marketing: {
      textKey: ' I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the <a href="https://stpancras-highspeed.com/privacy-policy/" target="_black">Privacy Policy</a>, and that I can unsubscribe at any time.'
    },
    // terms: {
    //   textKey: `I accept the {termsUrl} which includes privacy information as to data collection and usage.`,
    //   termsUrl: "/terms.html"
    // },
    privacy: {
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/"
    },
  },
  SB3: {
    title: "Marketing Permissions",
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    alternativeTerms: {
      title: "Bookings",
      paragraph: `We ask that you read our {privacyUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/",
      privacyUrlText: "Privacy Policy",

      label: `Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "https://www.sabaparking.co.uk/en/payment-services-terms-and-conditions",
      termsLabelUrlText: "Terms & Conditions",
    },
    marketing: {
      textKey: ' I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the Privacy Policy, and that I can unsubscribe at any time.'
    },
    privacy: {
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/"
    },
  },
  SB4: {
    title: "Marketing Permissions",
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    alternativeTerms: {
      title: "Bookings",
      paragraph: `We ask that you read our {privacyUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/",
      privacyUrlText: "Privacy Policy",

      label: `Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "https://www.sabaparking.co.uk/en/payment-services-terms-and-conditions",
      termsLabelUrlText: "Terms & Conditions",
    },
    marketing: {
      textKey: ' I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the Privacy Policy, and that I can unsubscribe at any time.'
    },
    privacy: {
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/"
    },
  },
  SB5: {
    title: "Marketing Permissions",
    createAccount: {
      title: "Create an account for fast checkout & self-serve changes",
      text: "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more.",
      privacyNoticeText: "Privacy Notice"
    },
    alternativeTerms: {
      title: "Bookings",
      paragraph: `We ask that you read our {privacyUrl}. Your booking information will be handled in accordance with these Privacy Notices.`,
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/",
      privacyUrlText: "Privacy Policy",

      label: `Click here to accept {termsLabelUrl} which includes privacy information as to data collection and usage.`,
      termsLabelUrl: "https://www.sabaparking.co.uk/en/payment-services-terms-and-conditions",
      termsLabelUrlText: "Terms & Conditions",
    },
    marketing: {
      textKey: ' I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the Privacy Policy, and that I can unsubscribe at any time.'
    },
    privacy: {
      privacyUrl: "https://stpancras-highspeed.com/privacy-policy/"
    },
  },
};